import { EXTERNAL_NAME } from '@meltwater/date-range/cjs/external-name'

import type { IDateRange, IDateRangeTypes } from './types.d'

const DateRangeModule = window[EXTERNAL_NAME] || ({} as any)

export const DateRange: IDateRange = DateRangeModule.DateRange
export const DateRangeTypes: IDateRangeTypes = DateRangeModule.DateRangeTypes
